// 定数をconstants/index.jsからインポート
import { SUBJECTS } from '../constants';

// 教科名取得関数
export const getSubjectName = (subjectId) => {
  const subject = SUBJECTS.find((s) => s.id === subjectId);
  return subject ? subject.name : subjectId;
};

// 英文前処理関数
export function preprocessEnglishSentence(sentence) {
  // 文の先頭の大文字を保持（小文字化しない）
  const processedSentence = sentence.trim();
  const lastPunctMatch = processedSentence.match(/[,.:;!?]$/);
  const lastPunct = lastPunctMatch ? lastPunctMatch[0] : null;
  const textWithoutLastPunct = lastPunct ? processedSentence.slice(0, -1).trim() : processedSentence.trim();
  const words = textWithoutLastPunct.split(/\s+/).reduce((acc, word) => {
    const matches = word.match(/^(.*?)([,.:;!?]*)$/);
    if (matches) {
      const [, baseWord, punctuation] = matches;
      if (baseWord) acc.push(baseWord);
      if (punctuation && punctuation !== lastPunct) acc.push(punctuation);
    } else {
      acc.push(word);
    }
    return acc;
  }, []);
  return { words, lastPunctuation: lastPunct, sentence: processedSentence };
}

// 英文並び替え問題で同じ単語が複数ある場合の正解パターンを生成する関数
export function generateCorrectAnswerPatterns(correctSentence, userWordsArray) {
  // より簡潔なアプローチ：正解文の各位置で同じ単語（大文字・小文字違い）を置換可能にする
  const correctWords = correctSentence.trim().replace(/[,.:;!?]+$/, '').split(/\s+/);
  const lastPunct = correctSentence.match(/[,.:;!?]+$/)?.[0] || '';
  
  console.log('=== generateCorrectAnswerPatterns デバッグ ===');
  console.log('正解文:', correctSentence);
  console.log('正解単語配列:', correctWords);
  console.log('ユーザー単語配列:', userWordsArray);
  
  // ユーザーが使用した単語のマッピング（表示用文字列 → 元の単語）
  const userWordMap = {};
  userWordsArray.forEach((wordObj) => {
    const originalWord = wordObj.content.split(':')[0]; // タグ情報を除去
    const displayWord = originalWord === 'I' ? 'I' : 
      originalWord.charAt(0).toLowerCase() + originalWord.slice(1);
    userWordMap[displayWord] = originalWord;
  });
  
  console.log('ユーザー単語マップ:', userWordMap);
  
  // 正解文の各単語を、同じ単語（大文字・小文字違い）で置換可能な形に変換
  const patterns = [correctWords.slice()]; // 元のパターンから開始
  
  correctWords.forEach((correctWord, index) => {
    const correctLower = correctWord.toLowerCase();
    
    console.log(`位置${index}の単語"${correctWord}"をチェック中...`);
    
    // ユーザーが使用した単語の中に、同じ単語（大文字・小文字違い）があるかチェック
    Object.entries(userWordMap).forEach(([displayWord, originalWord]) => {
      const originalLower = originalWord.toLowerCase();
      
      console.log(`  比較: "${correctWord}"(${correctLower}) vs "${originalWord}"(${originalLower})`);
      
      // 同じ単語だが大文字・小文字が異なる場合
      if (correctLower === originalLower && correctWord !== originalWord) {
        console.log(`    → マッチ！ "${correctWord}" を "${originalWord}" で置換可能`);
        // 新しいパターンを生成
        const newPatterns = patterns.map(pattern => {
          const newPattern = pattern.slice();
          newPattern[index] = originalWord;
          return newPattern;
        });
        patterns.push(...newPatterns);
      }
    });
  });
  
  // 重複を排除してパターンを文字列に変換
  const uniquePatterns = [...new Set(patterns.map(pattern => pattern.join(' ') + lastPunct))];
  
  console.log('生成されたパターン:', uniquePatterns);
  console.log('===========================================');
  
  return uniquePatterns;
}

// 配列シャッフル関数
export function shuffleArray(array) {
  const arr = [...array];
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
}

// 経過時間フォーマット関数
export const formatElapsedTime = (ms) => {
  const totalSeconds = Math.floor(ms / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${seconds.toString().padStart(2, '0')}`;
}; 